import React from 'react';
import { RouteObject } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDice } from '@fortawesome/free-solid-svg-icons';
import { DeepDiveWidget, WidgetHost } from '@/core/widgets/export';
import { Permissions } from '@/core/permissions/export';
import { FORECAST_FRENZY_WIDGET_ID } from '@/modules/calendar/services/forecast-game-service';
import ForecastFrenzyOverview from '@/modules/calendar/components/forecast-game/forecast-frenzy-overview';
import ForecastFrenzyPending from '@/modules/calendar/components/forecast-game/forecast-frenzy-pending';
import ForecastFrenzyBadges from '@/modules/calendar/components/forecast-game/forecast-frenzy-badges';
import ForecastFrenzyLayout from '@/modules/calendar/components/forecast-game/forecast-frenzy-layout';

export class ForecastFrenzyWidget implements DeepDiveWidget {
  get id(): string {
    return FORECAST_FRENZY_WIDGET_ID;
  }

  get defaultTitle(): string {
    return 'Forecast Frenzy';
  }

  get icon(): React.ReactNode {
    return <FontAwesomeIcon icon={faDice} />;
  }

  get headerPanel(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faDice} /> Forecast Frenzy
      </>
    );
  }

  get defaultRoute(): string {
    return '';
  }

  get routes(): RouteObject[] {
    return [
      {
        path: '',
        element: <ForecastFrenzyLayout />,
        children: [
          { index: true, element: <ForecastFrenzyOverview /> },
          { path: 'pending', element: <ForecastFrenzyPending /> },
          { path: 'badges', element: <ForecastFrenzyBadges /> },
        ],
      },
    ];
  }

  // Same HSC gating as DataCalendarWidget (this game only makes sense for
  // users who can see the HSC calendar and its forecast editor), plus alpha access.
  shouldHideToUser(permissions: string[]): boolean {
    const hasSelectAccess = permissions.some(value => Permissions.ANY_SELECT_PRODUCT.test(value));
    const hasAlphaAccess = permissions.includes(Permissions.ALPHA_ACCESS);

    return !hasSelectAccess || !hasAlphaAccess;
  }

  async hasPermission(permissions: string[]): Promise<boolean> {
    return !this.shouldHideToUser(permissions);
  }

  initialize(host: WidgetHost): void {}
}

export const forecastFrenzyWidget = new ForecastFrenzyWidget();
